import { BrandLogo } from "@/components/landing/BrandLogo";

export function Footer() {
  return (
    <footer className="relative mt-12 border-t border-border/60 py-12">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <BrandLogo size="footer" />
            <span className="font-display text-lg font-semibold">Jerry's Therapy</span>
          </div>
          <p className="mt-4 max-w-sm text-sm text-foreground/70">
            Licensed Professional Counseling in Minnesota. Telehealth and in-person sessions for
            individuals, couples, and families.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a
              href="https://www.facebook.com/JerrysTherapy/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Jerry's Therapy on Facebook"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-sage-deep transition-all hover:-translate-y-0.5 hover:bg-sage-soft hover:text-ink"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.7c0-.93.26-1.56 1.6-1.56H17V4.27A22.7 22.7 0 0 0 14.6 4.15c-2.4 0-4 1.46-4 4.14v2.31H8v3.2h2.6V22h2.9Z"/>
              </svg>
            </a>
            <a
              href="https://share.google/OmOBcogIaHKAGJA0t"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Jerry's Therapy on Google"
              className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-sage-deep transition-all hover:-translate-y-0.5 hover:bg-sage-soft hover:text-ink"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
                <path fill="#4285F4" d="M21.6 12.23c0-.73-.07-1.43-.19-2.1H12v3.97h5.39a4.6 4.6 0 0 1-2 3.02v2.51h3.23c1.89-1.74 2.98-4.3 2.98-7.4Z"/>
                <path fill="#34A853" d="M12 22c2.7 0 4.96-.9 6.62-2.43l-3.23-2.51c-.9.6-2.04.96-3.39.96-2.6 0-4.81-1.76-5.6-4.12H3.06v2.59A10 10 0 0 0 12 22Z"/>
                <path fill="#FBBC05" d="M6.4 13.9a6 6 0 0 1 0-3.8V7.51H3.06a10 10 0 0 0 0 8.98L6.4 13.9Z"/>
                <path fill="#EA4335" d="M12 5.96c1.47 0 2.79.5 3.83 1.5l2.87-2.87C16.96 2.97 14.7 2 12 2A10 10 0 0 0 3.06 7.5L6.4 10.1C7.19 7.74 9.4 5.96 12 5.96Z"/>
              </svg>
            </a>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Practice</div>
          <ul className="mt-4 space-y-1 text-sm">
            <li><a href="#approach" className="inline-flex min-h-11 items-center hover:text-sage-deep">Approach</a></li>
            <li><a href="#services" className="inline-flex min-h-11 items-center hover:text-sage-deep">Services</a></li>
            <li><a href="#about" className="inline-flex min-h-11 items-center hover:text-sage-deep">About Jerry</a></li>
            <li><a href="#faq" className="inline-flex min-h-11 items-center hover:text-sage-deep">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">Contact</div>
          <ul className="mt-4 space-y-1 text-sm">
            <li><a href="tel:5075302029" className="inline-flex min-h-11 items-center hover:text-sage-deep">(507) 530‑2029</a></li>
            <li><a href="mailto:jrbrmb123@yahoo.com" className="inline-flex min-h-11 items-center hover:text-sage-deep">jrbrmb123@yahoo.com</a></li>
            <li className="flex min-h-11 items-center">110 East Second Street, MN</li>
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-10 flex max-w-7xl flex-col items-start justify-between gap-2 border-t border-border/60 px-5 pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:px-8">
        <p>© {new Date().getFullYear()} Jerry's Therapy. All rights reserved.</p>
        <p>If you are in crisis, call or text 988 (US) or 911.</p>
      </div>
    </footer>
  );
}
